exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Act__headline___3svHT {\n  text-transform: lowercase;\n  font-size: 60px;\n  color: #000;\n  font-weight: 700;\n  margin-bottom: 10px;\n  line-height: 60px;\n}\n.Act__paragraph___2srHk {\n  font-size: 1em;\n  line-height: 1.6em;\n  color: #000;\n  margin-bottom: 70px;\n  margin-top: 0px;\n}\n.Act__button_wrapper___2zuAG button {\n  left: calc(50% - 110px);\n  width: 220px;\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"headline": "Act__headline___3svHT",
	"paragraph": "Act__paragraph___2srHk",
	"button_wrapper": "Act__button_wrapper___2zuAG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/static/Act.styl
// module id = 236
// module chunks = 0